module.exports = __webpack_public_path__ + "static/img/wealth_level_54.3aa718f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_54.png
// module id = rdiJ
// module chunks = 0